export default "__VITE_ASSET__DcG62LmY__"